var _class, _TimerSection;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Component } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import defined from "terriajs-cesium/Source/Core/defined";
import Timer from "../../Generic/Timer/Timer";
import { withTranslation } from "react-i18next";
import Styles from "./timer-section.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let TimerSection = observer(_class = (_TimerSection = class TimerSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      secondsLeft: 0
    };
  }
  isEnabled() {
    return (
      // only show refresh timer for refresh intervals less than 30 minutes
      defined(this.props.item) && this.props.item.isPolling && defined(this.props.item.nextScheduledUpdateTime) && this.props.item.refreshInterval < 30 * 60 * 1000
    );
  }
  getCountdownDuration() {
    // How many seconds until our next update?
    return Math.round((this.props.item.nextScheduledUpdateTime.getTime() - new Date().getTime()) / 1000);
  }
  getTimerStartTime() {
    return new Date(this.props.item.nextScheduledUpdateTime - this.props.item.refreshInterval * 1000);
  }

  // Ticks down the countdown clock
  countdown() {
    if (this.state.secondsLeft > 0) {
      this.setState(state => {
        return {
          secondsLeft: state.secondsLeft - 1
        };
      });
    } else {
      // Stop.
      clearInterval(this.interval);
    }
  }
  startCountdown() {
    this.setState({
      secondsLeft: this.getCountdownDuration()
    });
    this.interval = setInterval(() => this.countdown(), 1000);
  }
  getCountdownString() {
    const date = new Date(null);
    date.setSeconds(this.state.secondsLeft);
    const addLeadingZeroIfRequired = numString => numString.length < 2 ? "0" + numString : numString;
    const minutes = addLeadingZeroIfRequired(date.getMinutes().toString());
    const seconds = addLeadingZeroIfRequired(date.getSeconds().toString());
    return "00:".concat(minutes, ":").concat(seconds);
  }
  componentDidUpdate() {
    if (!this.isEnabled()) {
      return;
    }
    if (this.nextUpdate !== this.props.item.nextScheduledUpdateTime) {
      if (defined(this.interval)) {
        clearInterval(this.interval);
      }
      this.startCountdown();
      this.nextUpdate = this.props.item.nextScheduledUpdateTime;
    }
  }
  componentDidMount() {
    if (!this.isEnabled()) {
      return;
    }
    this.startCountdown();
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }
  render() {
    const {
      t
    } = this.props;
    return this.isEnabled() ? /*#__PURE__*/_jsxs("div", {
      className: Styles.section,
      children: [/*#__PURE__*/_jsx("div", {
        className: Styles.timerContainer,
        children: /*#__PURE__*/_jsx(Timer, {
          tooltipText: t("timer.nextScheduledUpdateTime", {
            scheduledUpdateTime: this.props.item.nextScheduledUpdateTime
          }),
          radius: 10,
          start: this.getTimerStartTime().getTime(),
          stop: this.props.item.nextScheduledUpdateTime.getTime()
        })
      }), /*#__PURE__*/_jsx("span", {
        children: t("timer.nextScheduledUpdateCountdown", {
          timeCountdown: this.getCountdownString()
        })
      })]
    }) : null;
  }
}, _defineProperty(_TimerSection, "propTypes", {
  item: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
}), _TimerSection)) || _class;
export default withTranslation()(TimerSection);